/**
 * Admin Agent Service
 * Handles all agent-related admin API calls
 */

import { getApi, postApi, updateApi } from '../adminApi';

/**
 * Get all agents
 * @param {Object} params - Query parameters
 * @returns {Promise}
 */
export const getAgents = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const endpoint = queryParams ? `agents?${queryParams}` : 'agents';
  return getApi(endpoint);
};

/**
 * Create a new agent
 * @param {Object} data - Agent data
 * @returns {Promise}
 */
export const createAgent = async (data) => {
  return postApi('agents', data);
};

/**
 * Update an agent
 * @param {string} agentId - Agent ID
 * @param {Object} data - Update data
 * @returns {Promise}
 */
export const updateAgent = async (agentId, data) => {
  return updateApi(`agents/${agentId}`, data);
};

